import React, { useState, useEffect } from "react";
import { Form, Input, InputNumber, Button, Row, Col, notification } from "antd";
import {
  TagOutlined,
  EnvironmentOutlined,
  PhoneOutlined,
} from "@ant-design/icons";
import { updateDocTypeApi } from "../../../../api/docType";
import { getAccessToken } from "../../../../api/auth";

import "./EditDocTypeForm.scss";

export default function EditDocTypeForm(props) {
  const { docType, setIsVisibleModal, setReloadDocTypes } = props;
  const [docTypeData, setDocTypeData] = useState({});

  //trae los datos de tipo de documento
  useEffect(() => {
    setDocTypeData({
      doctype_code: docType.doctype_code,
      description: docType.description,
    });
  }, [docType]);

  //Verifica que no exista errores en los datos que se deben validar
  const isFormValid = (e) => {
    let errorExists = false;
    if (!docTypeData.description) {
      notification["error"]({
        message: "Obligatorio: descripción.",
      });
      errorExists = true;
    } else {
      errorExists = false;
    }
    return errorExists;
  };

  const updateDocType = (e) => {
    e.preventDefault();
    const error = isFormValid();
    if (!error) {
      const token = getAccessToken();
      let docTypeUpdate = docTypeData; //es let porque se va actualizando

      updateDocTypeApi(token, docTypeUpdate, docType._id).then((result) => {
        if (
          result.message === "ERR_CONNECTION_REFUSED" ||
          result.message === "Failed to fetch" ||
          result.message === undefined
        ) {
          notification["error"]({
            message: "Servidor caido",
          });
          setIsVisibleModal(true);
        } else if (result.code !== 200) {
          notification["error"]({
            message: result.message,
          });
          setIsVisibleModal(true);
        } else {
          notification["success"]({
            message: result.message, //el mensaje que viene del server
          });
          //console.log("respuesta: " + result.message);
          setIsVisibleModal(false);
          setReloadDocTypes(true);
        }
      });
    }
  };

  return (
    <div className="edit-doctype-form">
      <EditForm
        docTypeData={docTypeData}
        setDocTypeData={setDocTypeData}
        updateDocType={updateDocType}
      />
    </div>
  );
}

function EditForm(props) {
  const { docTypeData, setDocTypeData, updateDocType } = props;

  return (
    <Form className="form-edit" onSubmit={updateDocType}>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col span={12}>
          <label className="control-label">Código</label>
          <Form.Item>
            <InputNumber
              prefix={<TagOutlined />}
              placeholder="Automático"
              value={docTypeData.doctype_code}
              onChange={(e) =>
                setDocTypeData({ ...docTypeData, doctype_code: e })
              }
              style={{ width: "100%" }}
              disabled={true}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <label className="control-label">
            <span className="control-required">* </span>Descripción
          </label>
          <Form.Item>
            <Input
              //   placeholder="descripción"
              value={docTypeData.description}
              onChange={(e) =>
                setDocTypeData({
                  ...docTypeData,
                  description: e.target.value,
                })
              }
            />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          className="btn-submit"
          onClick={updateDocType}
        >
          Actualizar
        </Button>
      </Form.Item>
    </Form>
  );
}
